import { SecureStorage } from '@ionic-native/secure-storage';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
// import { Http } from '@angular/http';
// import 'rxjs/add/operator/map';

/*
  Generated class for the SecureStorageProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class SecureStorageProvider {
  public storage: any;


  constructor(private secureStorage: SecureStorage, private unsecureStorage: Storage) {
  }
  getStorage() {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.storage) resolve(self.storage);
      else {
        self.secureStorage.create("consectus").then((s) => {
          self.storage = s;
          resolve(self.storage);
        })
          .catch((error) => {

            self.storage = self.unsecureStorage;

            //resolve(self.storage);
            reject(self.storage);
          })
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/secure-storage/secure-storage.ts